import * as React from "react";
import Modal from "react-bootstrap/Modal";
import Draggable from 'react-draggable';

export interface SilModalProps {
    title: string;
    closeModal: () => void;
    width?: number;
}

export class SilModal extends React.Component<SilModalProps, {}> {
    render() {
        const width = this.props.width != null ? `${this.props.width}px` : '100%';
        return (
            <Modal
                show={ true }
                animation = { false}
                //centered={true}
                onEscapeKeyDown={() => this.props.closeModal()}
                className="sil-modal"
                onHide={() => { /* don't allow hide via off-click*/ }}
                size="lg"
                //enforceFocus={true}
                style={{ zIndex: 10000, background: "rgba(000, 000, 000, 0.5)", minHeight: "1000000px" }}>
                <Draggable
                  axis="both"
                  handle=".ui-dialog-titlebar"
                >
                <div className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable" tabIndex={- 1} role="dialog" aria-labelledby="ui-dialog-title-tabeldevice" style={{ display: "block", zIndex: 10002, outline: "0px", height: "auto", width: width }}>
                    <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix sil-modal-title" >
                        <span className="ui-dialog-title modal-title-text" id="ui-dialog-title-tabeldevice" > {this.props.title} </span>
                        <div className="sil-modal-close" role="button" >
                            <div className="sil-modal-hover-box" >
                                <span className="ui-icon ui-icon-closethick" style={{ cursor: "pointer" }} onClick={() => this.props.closeModal()}> close </span>
                            </div>
                        </div>
                    </div>
                    <div id="tabeldevice" className="ui-dialog-content ui-widget-content" style={{ display: "block", width: "auto", minHeight: "0px", height: "auto" }}>
                        {this.props.children}
                    </div>
                </div>
                </Draggable>
                </Modal>
        );
    }
}